<template>
  <div class="challenge-progress-state">
    <div class="sections">
      <div class="section">
        <div class="state-number">{{ daysPassed }}</div>
        <div class="state-description">ימים עברו</div>
      </div>
      <div class="vertical-separator"/>
      <div class="section">
        <div class="state-number">{{ formatAmount(leftToSpend) }}</div>
        <div class="state-description">נותרו</div>
      </div>
      <div class="vertical-separator"/>
      <div class="section">
        <div class="state-number">{{ daysLeft }}</div>
        <div class="state-description">ימים נשארו</div>
      </div>
    </div>
    <separator/>
  </div>
</template>

<script>

import moneyUtils from '@/utils/money';
import BaseUI from 'base-ui';

export default {
  name: 'ChallengeProgressState',
  props: {
    daysPassed: {
      type: Number,
      required: true,
    },
    daysLeft: {
      type: Number,
      required: true,
    },
    leftToSpend: {
      type: Number,
      required: true,
    },
  },
  components: {
    Separator: BaseUI.Separator,
  },
  methods: {
    formatAmount(amount) {
      const formattedAmount = moneyUtils.formatAmountWithFraction(Math.max(amount, 0), 0);
      return `${formattedAmount} ₪`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../scss/mixins';
.challenge-progress-state {
  .sections {
    margin-bottom: 30px;
    height: 80px;
    display: flex;
    justify-content: space-around;
    font-family: SimplerPro;
    .section {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .state-number {
        margin-bottom: 10px;
        font-size: 18px;
        color: $riseup_black;
        font-weight: bold,
      }
      .state-description {
        font-size: 14px;
        color: $riseup-blue;
      }
    }
    .vertical-separator {
      width: 1px;
      background: $riseup_gray_0;
    }
  }
}

</style>
